import { coursedata, settings, userprofile } from './settingsReducer/settingsReducer';

import appDataReducer from 'reducers/appData';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { roledata } from './userReducer/userReducer';

export default hist =>
  combineReducers({
    settings: settings,
    router: connectRouter(hist),
    userprofile: userprofile,
    coursedata: coursedata,
    roledata: roledata,
    AppData: appDataReducer,
    loadingBar: loadingBarReducer,
  });
